export const VALIDATE_RESET_TOKEN_BEGIN = 'validate_reset_token_begin';
export const VALIDATE_RESET_TOKEN_SUCCESS = 'validate_reset_token_success';
export const VALIDATE_RESET_TOKEN_ERROR = 'validate_reset_token_error';
export const VALIDATE_RESET_TOKEN_RESET = 'validate_reset_token_reset';

export const RESET_PASSWORD_BEGIN = 'reset_password_begin';
export const RESET_PASSWORD_SUCCESS = 'reset_password_success';
export const RESET_PASSWORD_ERROR = 'reset_password_error';
export const RESET_PASSWORD_RESET = 'reset_password_reset';